import {Component, Input, OnInit} from '@angular/core';
import * as _ from 'underscore';
import moment from 'moment';
import { Chart, ChartOptions,Colors } from 'chart.js';
Chart.register(Colors);

@Component({
    selector: 'app-small-ccr-chart',
    templateUrl: './small-ccr-chart.component.html',
    styleUrls: ['./small-ccr-chart.component.scss'],
    standalone: false
})
export class SmallCcrChartComponent implements OnInit {
    @Input()
    entityCcrChartData: any[];

    public lineChartOptions: ChartOptions<'line'> = {
        // We use these empty structures as placeholders for dynamic theming.
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            tooltip:{
                enabled:false
            },
        },
        layout: {
            padding: {
                left: 3,
                right: 3,
                top: 0,
                bottom: -4
            }
        },
        scales: {
            x: {
                type: 'time',
                time: {
                    unit: 'year',
                    displayFormats: {
                        quarter: 'YYYY'
                    }
                },
                grid: {
                    display: false
                },
                ticks:{
                    display: false
                },
            },
            y: {
                max: 191098,
                min: 2618,
                grid: {
                    display: false
                },
                ticks: {
                    display: false,
                }
            }
        },
    };

/*     public chartOptions: any = {
        name: 'smallCcrChart',
        lineAt: 150,
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
            enabled: false
        },
        layout: {
            padding: {
                left: 3,
                right: 3,
                top: 0,
                bottom: -4
            }
        },
        scales: {
            xAxes: [{
                type: 'time',
                distribution: 'linear',
                time: {
                    unit: 'year',
                    stepSize: 1,
                    tooltipFormat: 'll',
                    displayFormats: {
                        year: 'YYYY'
                    }
                },
                gridLines: {
                    display: false,
                    drawBorder: false
                },
                ticks: {
                    display: false
                }
            }],
            yAxes: [{
                gridLines: {
                    display: false,
                    drawTicks: false,
                    drawBorder: false
                },
                ticks: {
                    display: false,
                    max: 550,
                    min: 50
                }
            }]
        }
    }; */
    public chartLabels: number[] = [0, 0.5, 1, 2, 3, 4, 5, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36, 39, 42, 45, 48, 51, 54, 57, 60, 63, 66,
        69, 72, 75, 78, 81, 84, 87, 90, 93, 96, 99, 102, 105, 108, 111, 114, 117, 120];
    public dateFormatLabels: Date[] = [];
    public chartType = 'line';
    public chartLegend = false;


    public chartData: any[];

    colorArray = [{
        backgroundColor: 'blue',
        hoverBackgroundColor: 'blue',
        borderColor: 'blue',
        hoverBorderColor: 'blue'
    }, {
        backgroundColor: 'blue',
        hoverBackgroundColor: 'blue',
        borderColor: 'white',
        hoverBorderColor: 'blue'
    }];

    constructor() {
    }

    chartInit(): void {
        const min = _.min(this.entityCcrChartData, x => x);
        const max = _.max(this.entityCcrChartData, x => x);
        this.lineChartOptions.scales.y.max = Math.floor(max);
        this.lineChartOptions.scales.y.min = Math.floor(min);
        const minIndex = _.indexOf(this.entityCcrChartData, min);
        this.chartData = [{
            backgroundColor: 'blue',
            hoverBackgroundColor: 'blue',
            borderColor: 'blue',
            hoverBorderColor: 'blue',
            lineTension: 0.25,
            borderWidth: 1.25,
            pointRadius: 0,
            pointHoverRadius: 0,
            data: this.entityCcrChartData
        }, {
            backgroundColor: 'blue',
            hoverBackgroundColor: 'blue',
            borderColor: 'white',
            hoverBorderColor: 'blue',
            fill: false,
            lineTension: 0.25,
            borderWidth: 1,
            pointRadius: 3,
            pointHoverRadius: 0,
            data: [{x:  moment().add(this.chartLabels[minIndex], 'months').toDate(), y: min}]
        }];
    }

    ngOnInit() {
        this.dateFormatLabels = _.map(this.chartLabels, x => {
            const date = new Date();
            const year = date.getFullYear();
            const month = date.getMonth();
            if (x === 0.5) {
                return moment().add(15, 'days').toDate();
            }
            return moment().add(x, 'months').toDate();
        });
        this.registerChartPlugin();
        this.chartInit();
    }

    public registerChartPlugin() {
   /*      Chart.pluginService.register({
            beforeDatasetDraw: function (chart) {
                if (chart.config.options.name !== undefined && chart.config.options.name === 'smallCcrChart'
                    && chart.config.options.lineAt !== undefined) {
                    let lineAt = chart.config.options.lineAt;
                    const ctxPlugin = chart.chart.ctx;
                    const xAxe = chart.scales[chart.config.options.scales.xAxes[0].id];
                    const yAxe = chart.scales[chart.config.options.scales.yAxes[0].id];

                    ctxPlugin.strokeStyle = 'red';
                    ctxPlugin.beginPath();
                    ctxPlugin.lineWidth = 1;
                    lineAt = (lineAt - yAxe.min) * (100 / yAxe.max);
                    lineAt = (100 - lineAt) / 100 * (yAxe.height) + yAxe.top;
                    ctxPlugin.moveTo(xAxe.left, lineAt);
                    ctxPlugin.lineTo(xAxe.right, lineAt);
                    ctxPlugin.stroke();

                }
            }
        }); */
    }
}
